<div class="a00320">
    <a [href]="button.link" [attr.target]="'_blank'" class="text">
        <img class="a00320__icon" [src]="button.icon" [alt]="'podcast icon'" />
    </a>
</div>
